import { render } from "./FaenaDonut.vue?vue&type=template&id=2d5425c2"
import script from "./FaenaDonut.vue?vue&type=script&lang=js"
export * from "./FaenaDonut.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__